import '@ids/style-card';

import { useState } from 'react';

import { IdsIcon } from '../../components/icon/Icon';
import type { Action, Content } from '../../global-types/Content';
import useTracking from '../../hooks/useTracking';
import { renderContent } from '../../utils/renderContent';

type SmallCardProps = {
  content: Content;
  viewId: number | undefined;
  dispatchActionEvent: (action: Action) => void;
};

function SmallCard({ content, viewId, dispatchActionEvent }: SmallCardProps) {
  const trackVisibilityElement = useTracking(content, viewId ?? undefined);
  const view = viewId ? content.contentViews?.find((cv) => cv.contentViewId === viewId) : undefined;
  const [disableButton, setDisableButton] = useState(false);
  if (view === undefined) return null;

  const media = view.viewElements.media?.[0];
  const { texts, linkStyledActions, buttonStyledActions } = renderContent({
    view,
    trackVisibilityElement,
    actionsConfig: {
      dispatchActionEvent,
      skipFirstAction: false,
      disableButton,
      setDisableButton,
    },
  });

  return (
    <li className="if card elevated ">
      <div className="if p-24 justify-content-space-between flex flex-column size-h-100p">
        {view.viewElements.icons && (
          <div className="if pb-8">
            <IdsIcon name={view.viewElements.icons[0]} size={24} />
          </div>
        )}
        <div className="if align-content-center">{texts}</div>

        <div className="if flex align-items-end justify-content-space-between links">
          {linkStyledActions.length > 0 && linkStyledActions}
          {media && <img className="if size-h-96" src={media.url} alt={media.alt} />}
        </div>
        {buttonStyledActions.length > 0 && (
          <div className="if flex flex-center gap-16 buttons flex-column">{buttonStyledActions}</div>
        )}
      </div>
    </li>
  );
}

export default SmallCard;
